import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import Form from './Form';
import config from 'config';
import { ApiService } from '../../../services';
import { getPreviewSrc, encodeFileName } from '../../../helpers/filesPreview';

import './Edit.scss';

export interface StaffAlta {
  id: string | undefined;
  nombre: string;
  apellido: string;
  delegacion: string;
  es_director: boolean;
}

export interface StaffBaja {
  id: string | undefined;
  nombre: string;
  apellido: string;
  delegacion: string;
  es_director: boolean;
}

export interface StaffMultipleRequest {
  matriculate: {
    id: string | undefined;
    nombre: string;
    apellido: string;
    delegacion: string;
  };
  staff_alta: StaffAlta[];
  staff_baja: StaffBaja[];
  calle: string;
  numero: string;
  piso: string;
  departamento: string;
  localidad_name: string;
  partido_name: string;
  codigo_postal: string;
  dias_horarios_atencion: string;

  motivo_rechazo: string;

  state_id: string;

  attachs: RequestAttachment[];
}

export interface GalleryItem {
  src: string;
  downloadUrl: string;
  alt: string;
}

export interface RequestAttachment {
  id: number;
  request_id: number;
  request_type: string;
  attachment_type: string;
  url: string;
  created_at: string;
}

function View() {
  const { id } = useParams();

  const [data, setData] = useState<StaffMultipleRequest>({
    matriculate: {
      id: id,
      nombre: '',
      apellido: '',
      delegacion: '',
    },
    staff_alta: [],
    staff_baja: [],
    calle: '',
    numero: '',
    piso: '',
    departamento: '',
    localidad_name: '',
    partido_name: '',
    codigo_postal: '',
    dias_horarios_atencion: '',

    motivo_rechazo: '',

    state_id: '',

    attachs: [],
  });

  const [gallery, setGallery] = useState<GalleryItem[]>([]);
  const galleryContainer = useRef(null);

  const [isLoading, setIsLoading] = useState(true);


  const ATTACHMENTS_CONFIG = [
    { key: 'constancia_pagos', alt: 'Constancia de Pagos' },
    { key: 'solicitud_habilitacion', alt: 'Solicitud de Habilitación' },
    { key: 'resolucion_ministerio', alt: 'Resolución del Ministerio' },
    { key: 'titulos_grado', alt: 'Título de Grado' },
    { key: 'constancia_cuit', alt: 'Constancia de CUIT' },
  ] as const;

  useEffect(() => {
    ApiService.getOne('matriculates/staff-multiple-request', id)
      .then(({ payload }) => {
        setData(payload);

        const attachs = ATTACHMENTS_CONFIG.flatMap(({ key, alt }) => {
          if (!payload.attachs?.length) return [];

          const filtered = payload.attachs
            .filter((a: RequestAttachment) => a.attachment_type.startsWith(key))
            .map((a: RequestAttachment) => {
              const rest = a.attachment_type.replace(`${key}_`, '');

              const parts = rest.split('_');

              let matricula: string | null = null;
              let index = 0;

              if (parts.length === 2) {
                matricula = parts[0];
                index = parseInt(parts[1] || '0');
              } else {
                index = parseInt(parts[0] || '0');
              }

              return {
                ...a,
                matricula,
                index,
              };
            })
            .sort((a: any, b: any) => a.matricula - b.matricula);

          return filtered.map((a: any) => {
            const encodedPath = encodeFileName(a.url);

            return {
              src: getPreviewSrc(encodedPath),
              downloadUrl: `${config.baseUrl}/${encodedPath}`,
              // @ts-ignore
              alt: a.matricula
                ? `${alt} (MP ${a.matricula})`
                : `${alt}`,
            };
          });
        });

        setGallery(attachs);
      })
      .finally(() => setIsLoading(false));
  }, [id]);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body"></div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Card className="bg-secondary shadow">
          <CardHeader>
            <Row>
              <Col md="8">
                <h3 className="mb-0">Solicitud de Staff #{ id }</h3>
              </Col>
              <Col md="4" className="text-right">
                <Link to='/admin/matriculates/requests'>
                  <Button color="primary" size="md">Volver</Button>
                </Link>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form
              data={ data }
              setData={ setData }
              gallery={ gallery }
              galleryContainer={ galleryContainer }
              isLoading={ isLoading }
              onAccept={ false }
              onReject={ false }
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default View;
